module.exports = __webpack_public_path__ + "static/img/shop-list-null.66298b50.png";